import { create } from "zustand";

type SortableTabs = "flagged" | "deleted";
type SortConfig = { key: string; direction: "asc" | "desc" };

interface AdminState {
    activeTab: string;
    sortConfigs: Record<SortableTabs, SortConfig>;
    setActiveTab: (tab: string) => void;
    setSortConfig: (config: SortConfig | ((prev: SortConfig) => SortConfig)) => void;
    getSortConfig: (tab?: SortableTabs) => SortConfig;
}

const defaultSortConfigs: Record<SortableTabs, SortConfig> = {
    flagged: { key: "last_updated", direction: "desc" },
    deleted: { key: "last_updated", direction: "desc" },
};

const adminStore = create<AdminState>()((set, get) => ({
    activeTab: "users",
    sortConfigs: defaultSortConfigs,

    setActiveTab: (tab: string) => set({ activeTab: tab }),

    setSortConfig: (config) =>
        set((state) => {
            const newConfig = typeof config === "function" ? config(state.sortConfigs[state.activeTab]) : config;
            return {
                sortConfigs: {
                    ...state.sortConfigs,
                    [state.activeTab]: newConfig,
                },
            };
        }),

    getSortConfig: (tab?: SortableTabs) => {
        const state = get();
        const targetTab = tab || state.activeTab;
        return state.sortConfigs[targetTab];
    },
}));

export default adminStore;